import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupConfirmation extends PopupBasic {
  private buttonOkay: ButtonScaleViewWithText;
  private buttonCancel: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: (result: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      zIndex: 11000,
      width: uiConfig.popups.minimumWidth,
      height: uiConfig.popups.minimumHeight,
      darkerBg: false,
      tracking: { feature: 'generic', $subFeature: 'popup-confirmation' },
    });

    this.buttonClose.removeFromSuperview();

    this.box.addSubview(
      new ImageScaleView({
        ...uiConfig.popups.scrollBox,
        x: 30,
        y: 55,
        width: this.box.style.width - 60,
        height: 315,
      }),
    );

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 315,
      x: 40,
      y: 55,
      zIndex: 1,
      color: '#9C490D',
      wordWrap: true,
    });

    this.buttonOkay = new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      labelOffsetY: -1,
      fontSize: 31,
      font: 'Body',
      x: this.box.style.width / 2 + 105,
      y: this.box.style.height - 45 - 80 / 2,
      width: 200,
      height: 80,
      centerOnOrigin: true,
      onClick: async () => opts.close(true),
      tracking: { feature: 'generic', $subFeature: 'popup-confirmation-ok' },
    });

    this.buttonCancel = new ButtonScaleViewWithText({
      ...uiConfig.buttons.cancel,
      superview: this.box,
      labelOffsetY: -1,
      fontSize: 31,
      font: 'Body',
      x: this.box.style.width / 2 - 105,
      y: this.box.style.height - 45 - 80 / 2,
      width: 200,
      height: 80,
      centerOnOrigin: true,
      onClick: async () => opts.close(false),
      tracking: {
        feature: 'generic',
        $subFeature: 'popup-confirmation-cancel',
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init(opts: {
    title: string;
    message: string;
    buttonOkay?: string;
    buttonCancel?: string;
  }) {
    super.init(opts);

    if (opts.buttonOkay) {
      this.buttonOkay.localeText = () => opts.buttonOkay!;
    } else {
      this.buttonOkay.localeText = () => i18n('basic.okay');
    }

    if (opts.buttonCancel) {
      this.buttonCancel.localeText = () => opts.buttonCancel!;
    } else {
      this.buttonCancel.localeText = () => i18n('basic.cancel');
    }
  }
}
